import { ALERT_SHOWING, type AlertKey } from './filters';
import { Link, useRoute } from '../lib/router';
import { useFlag } from '../shell/hooks';

// The library alert line (Shelves Part 5, Kristi, Oct 29): at the top of the Reading tab, only
// when a library step needs you. Each part shows its books on the shelves through a Library chip;
// "Back to your filters" (or ✕ on that chip) puts back the filters you had before. No ✕ on the
// line itself: it goes away once the steps are updated. From My books Part 2 (Kristi, Oct 31) the
// line ends with See all library copies ›, to My books › Library copies; tapping a part still filters.
// Consistency pass (R5, Kristi Nov 1): its parts and links are the Link look (btn-link), full tap size.

export interface AlertPart {
  key: AlertKey;
  count: number;
  words: string;
}

export function LibraryAlert({
  parts,
  showing,
  left,
  onPick,
  onBack,
}: {
  parts: AlertPart[];
  /** The part whose books are showing, when one was tapped. */
  showing: AlertKey | null;
  /** Books still showing (0 once every one is updated). */
  left: number | null;
  onPick: (k: AlertKey) => void;
  onBack: () => void;
}) {
  const myBooks = useFlag('my_books');
  const { path } = useRoute();
  if (showing) {
    return (
      <div class="library-alert" role="status">
        <span>
          {left === 0 ? 'Nothing left from the library line: all updated.' : `Showing ${ALERT_SHOWING[showing]} from the library line.`}{' '}
          <button type="button" class="btn-link" onClick={onBack}>
            Back to your filters
          </button>
        </span>
      </div>
    );
  }
  if (!parts.length) return null;
  return (
    <div class="library-alert" role="region" aria-label="Library">
      <span class="library-alert-head">Library:</span>{' '}
      {parts.map((p, i) => (
        <span key={p.key}>
          {i ? <span aria-hidden="true"> · </span> : null}
          <button type="button" class="btn-link" onClick={() => onPick(p.key)}>
            {p.words}
          </button>
        </span>
      ))}
      {myBooks ? (
        <>
          {' '}
          <Link href="/my-books/library" state={{ from: path }} class="btn-link library-alert-all">
            See all library copies ›
          </Link>
        </>
      ) : null}
    </div>
  );
}
